import { Outlet } from "react-router";
import { UserSessionTimeout } from "components/common/Auth";
import Redirect from "components/common/Redirect";
import { Loading } from "components/shared";
import { Path } from "utils/constants/paths.constants";
import useSessionCheck from "./hooks/useSessionCheck";

export const SecureRoute = () => {
  const { isLoading, isAuthenticated } = useSessionCheck();

  if (isLoading) {
    return <Loading />;
  }

  return isAuthenticated ? (
    <>
      <UserSessionTimeout />
      <Outlet />
    </>
  ) : (
    <Redirect path={Path.Login} />
  );
};
